const Dark = {
  title: 'light',
  colors: {
    primary: '#320E3B',
    secondary: '#CC59D2',
    tertiary: '#B9C6AE',
    quaternary: '#DF2935',
    quinary: '#585B56',

    background: '#eee',
    text: '#333',

    navbar: {
      download: '#F5F5F5',
      downloadHover: '#F5F5F5',
      donwloadActive: '#320E3B',
      toggleDarkModeActive: '#f29515',
      toggleDarkModeHover: '#ffdb16',
    },

    hero: {
      bg1: '#536976dd',
      bg2: '#292e49dd',
      lines: '#CC59D2',
    },
  },
};

export default Dark;